import "./tcredit-btn.css";

const TcreditBtn = ({ disabled, onClick }) => {

  return<div className={"tcredit-btn-main" + (disabled ? " tcredit-btn-disabled" : "")}>
    <div className="tcredit-btn" onClick={disabled ? null : onClick} >
      <img src={disabled ? "/images/tcredit-gray.svg" : "/images/tcredit-active.svg"} alt="sp" />
      <div>Кредит</div>
  </div></div>
}

export default TcreditBtn;